// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import StarsIcon from "@material-ui/icons/Stars";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { WhiteText, GreyLightText } from "../../../global/uis/scss";

type CompanyTypeLabelPropsType = {
  status: number,
  classes: { [key: string]: string }
};

const styles = theme => ({
  root: {
    paddingRight: "32px",
  },
  badge: {
    top: "50%",
  },
  grey: {
    color: WhiteText,
    backgroundColor: GreyLightText,
  },
  icon: {
    verticalAlign: "middle",
  },
  text: {
    paddingRight: "10px",
    verticalAlign: "-11%",
  },
});

class CompanyTypeLabel extends Component<*, CompanyTypeLabelPropsType> {

  render(): * {
    const type = this.props.type;
    const authority = this.props.authority;
    const classes = this.props.classes;
    if(type === "I"){
      return (
        <Typography variant="subtitle1"><span className={classes.text}>Admin</span><StarsIcon className={"green-icon medium-icon " + classes.icon} /></Typography>
      );
    }
    else if (type === "D"){
      return (
        <Typography variant="subtitle1"><span className={classes.text}>Distributor</span><StarIcon className={"green-icon medium-icon " + classes.icon} /></Typography>
      );
    }
    else if (type === "R"){
      if (authority === 1) {
        return (
          <Badge 
            color="primary"
            badgeContent={"\u2714"}
            classes={{ badge: classes.badge, root: classes.root }}>
            <Typography variant="subtitle1">Authorised Reseller</Typography>
          </Badge>
        );
      }
      else if (authority === 0) {
        return (
          <Badge 
            color="secondary"
            badgeContent={"\u2573"} 
            classes={{ badge: classes.badge, root: classes.root }}>
            <Typography variant="subtitle1">Authorised Reseller</Typography>
          </Badge>
        );
      }
      else {
        return (
          <Badge 
            color="default"
            badgeContent={"\u002F"}
            classes={{ badge: classNames(classes.badge, classes.grey), root: classes.root }}>
            <Typography variant="subtitle1">Standard Reseller</Typography>
          </Badge>
        );
      }
    }
    else if (type === "E"){
      return (
        <Typography variant="subtitle1"><span className={classes.text}>End User</span><StarBorderIcon className={"green-icon medium-icon " + classes.icon} /></Typography>
      );
    }
    else {
      return (
        <Typography variant="subtitle1"></Typography>
      );
    }
  }
}

export default withStyles(styles)(CompanyTypeLabel);
